import React from "react";

import {bindActionCreators} from "redux";
import {withRouter, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import {Modal, Button, message, Table, Tooltip, Input, Space, Checkbox} from "antd";

import arrowLeft from "../../assets/img/icon/arrow-left-icon.svg";
import "./productFeaturesDashboard.scss";
import {DeleteFilled, SendOutlined} from "@ant-design/icons";


class ProductFeaturesDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            packages: [],
            modalData: {},
            pageSize: 50,
            page: 1,
            total: 0,
            deleted: false,
            visible: false
        };
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    componentDidMount() {
        this.setState({
            loading: true,
        });
        this.fetchAllUsers();
    }

    fetchAllUsers() {
        CloudFlyerAPI.product_features
            .getAllFeatures(this.state.pageSize, this.state.page, this.state.deleted)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: false,
                    packages: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onPageChange = page => {
        this.setState({page: page, loading: true})


        this.fetchAllUsers();
    }

    handleDeleteClick(id) {
        CloudFlyerAPI.product_features
            .deleteFeature(id)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: true,
                });
                this.fetchAllUsers();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    render() {
        const {history} = this.props;
        const showDeleteConfirm = (
            e,
            handleDeleteClick,
            id) => {
            e.stopPropagation()
            Modal.confirm({
                title: `Are you sure you want to Delete this Feature?`,
                content:
                    "",
                onOk() {
                    handleDeleteClick(id)
                }
            })
        }

        const columns = [
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 100,
            },
            {
                title: "Description",
                dataIndex: "description",
                key: "description",
                width: 130,
            },
            {
                title: "Price",
                dataIndex: "price",
                key: "price",
                ellipsis: {
                    showTitle: false,
                },
                render: (accountName) => (
                    <Tooltip placement="topLeft" title={accountName}>
                        {accountName}
                    </Tooltip>
                ),
                width: 70,
            },
            {
                title: "Price Id",
                dataIndex: "priceId",
                key: "priceId",
                width: 90,
            },
            {
                title: "Duration",
                dataIndex: "duration",
                key: "duration",
                width: 90,
            },
            {
                title: "Feature Type",
                dataIndex: "featureType",
                key: "featureType",
                width: 90,
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                width: 100,
                ellipsis: {
                    showTitle: false,
                },
                render: action => (
                    <div className="userActions">
                        <Tooltip placement="topLeft" title="Detail">
                            <Button
                                className="replication-delete-btn"
                                icon="edit"
                                onClick={(e) => {
                                    // Setting the modal data to the clicked feature's data
                                    this.state.modalData = action.postData.data;

                                    // Encoding the modal data as a query string
                                    const queryString = encodeURIComponent(JSON.stringify(this.state.modalData));

                                    // Navigating to the edit page with the encoded query string
                                    this.props.history.push("/editFeature/?data=" + queryString);
                                }}
                            />
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Delete Feature">
                            <DeleteFilled className={action.status} onClick={e =>
                                showDeleteConfirm(e, this.handleDeleteClick, action.id,)
                            }/>
                        </Tooltip>
                    </div>
                ),
            }
        ];

        let featureType = new Map();
        featureType.set(4, "AdminUser");
        featureType.set(8, "CreativeUser");
        featureType.set(16, "StandardUser");
        featureType.set(32, "Connection");
        featureType.set(64, "Project");
        featureType.set(128, "Team");
        featureType.set(256, "Drive");
        featureType.set(512, "Sync");
        featureType.set(1024, "SSO");
        featureType.set(2048, "Logs");
        featureType.set(4096, "FreeUser");
        featureType.set(8192, "FreeConnection");

        let data = this.state?.packages?.map((t, index) => {
            return {
                key: t.id,
                id: t.id,
                name: t.name,
                description: t.description,
                price: t.price,
                priceId: t.priceId,
                duration: t.duration === 1 ? "Monthly" : "Annual",
                featureType:  featureType.get(t.featureType),
                action: {
                    id: t.id,
                    postData: {
                        data: t,
                        id: t.id,
                        username: t.username,
                        email: t.username,
                        firstname: t.firstname,
                        lastname: t.lastname,
                    },
                    detailData: {id: t.id, name: t.accountName, accountId: t.accountId}
                }
            };
        });

        const packageColumns = [
            {
                title: '',
                dataIndex: 'attribute',
                key: 'attribute',
            },
            {
                title: '',
                dataIndex: 'value',
                key: 'value',
                align: 'center',
            },
        ];

        const packageData = [
            { key: '1', attribute: 'Name', value: this.state.modalData.name },
            { key: '2', attribute: 'Description', value: this.state.modalData.description },
            { key: '3', attribute: 'Price', value: this.state.modalData.price },
            { key: '4', attribute: 'Price ID', value: this.state.modalData.priceId },
            { key: '5', attribute: 'Duration', value: this.state.modalData.duration === 1 ? "Monthly" : "Annual" },
            { key: '6', attribute: 'Feature Type', value: featureType.get(this.state.modalData.featureType)}
        ];

        return (
            <div className="usersListdashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2 className="title-back"><NavLink to="/"><img src={arrowLeft} alt="icon"/></NavLink>Features</h2>
                    </div>
                    <div className="right-wrapper">
                        <div className="text-left">

                            <Checkbox onChange={(e) => {
                                console.log(e.target.checked)
                                this.state.deleted = e.target.checked;

                                this.setState({
                                    loading: true,
                                });
                                this.fetchAllUsers();
                            }} defaultChecked={false}>Deleted</Checkbox>

                        </div>

                        <Button
                            className="add-user-btn"
                            type="primary"
                            onClick={() => history.push("/addNewFeature")}>
                            Add New Feature
                        </Button>
                    </div>
                </div>
                <div className="active-jobs-wrapper-list">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />

                </div>

                <Modal
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button onClick={this.handleCancel}>
                            Cancel
                        </Button>,
                        <Button type="primary" onClick={()=>{


                            const queryString = encodeURIComponent(JSON.stringify(this.state.modalData));

                            this.props.history.push("/editFeature/?data=" + queryString );
                        }}>
                            Edit
                        </Button>,
                    ]}
                    className={"detail-modal"}
                >
                    <h3 className="text-center">Feature Detail</h3>
                    <Table columns={packageColumns} dataSource={packageData} pagination={false} bordered  size="small" showHeader={false}/>
                </Modal>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth, cloudAccounts}, {match, history}) => {
            let user = auth.user;
            return {
                ...user,
                cloudAccounts,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(ProductFeaturesDashboard)
);
